import React from 'react'
import Paper from '@material-ui/core/Paper'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import Typography from '@material-ui/core/Typography'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import MenuContent from '../../components/MenuContent'

const MasterTab = props => {
    const [value, setValue] = React.useState(0)
    const tabProps = props.masterTabProp
    const isProgram = props.data.isProgram
    const tabs = []
    const tabIcons = []
    const tabContentProps = []
    const tabHeaderProps = []
    let componentRoute = ''

    if (tabProps && tabProps.length > 0) {
        tabProps.map((data, key) => {
            tabs.push(tabProps[key].menuItem)
            tabIcons.push(tabProps[key].fontIcon)
            tabContentProps.push(tabProps[key].tabContentProps)
            tabHeaderProps.push(tabProps[key].tabHeaderProps)
            return true
        })
        componentRoute = tabProps[value].router
    }
    const handleChange = (event, newValue) => {
        setValue(newValue)
    }

    const TabPanel = props => {
        if (componentRoute !== '') {
            return (
                <MenuContent
                    isProgram
                    registryInfo={{showPaymentDetails: props.tabSection.data.payment}}
                    componentName={componentRoute}
                />
            )
        } else {
            return (
                <div className="mastertab-outer">
                    <Typography variant="h4" gutterBottom>
                        Need to add component/container here.
                    </Typography>
                </div>
            )
        }
    }

    return (
        <Paper square className="tab_master-wrapper myacc-stl__wrapper">
            <Tabs
                value={value}
                onChange={handleChange}
                variant="fullWidth"
                indicatorColor="primary"
                textColor="primary"
                aria-label="icon tabs example"
            >
                {tabs.map((tab, key) => {
                    if (tabIcons[key]) {
                        return (
                            <Tab
                                className="mastertab__tab__tab-content"
                                key={tab}
                                label={
                                    <span className="mastertab__tab__title">{tab}</span>
                                }
                                {...tabHeaderProps[key]}
                                icon={
                                    <FontAwesomeIcon
                                        icon={['fal', tabIcons[key]]}
                                        className="tabgroup__iconimage"
                                    />
                                }
                            />
                        )
                    }
                    return <Tab key={tab} label={tab} />
                })}
            </Tabs>
            <div className="master-tab-content__wrapper">
                <TabPanel value={value} tabSection={props.data} index={0}>
                    Item One
                </TabPanel>
            </div>
        </Paper>
    )
}
MasterTab.defaultProps = {
    masterTabProp: [
        {
            menuItem: 'PROGRAM INFO',
            defaultActiveIndex: false,
            fontIcon: 'users-crown',
            router: '',
            tabContentProps: null,
            tabHeaderProps: {},
        },
        {
            menuItem: 'CLINICIAN DETAILS',
            defaultActiveIndex: true,
            fontIcon: 'user-md',
            router: '',
            tabContentProps: null,
            tabHeaderProps: {},
        },
        {
            menuItem: 'PAYMENT HISTORY',
            defaultActiveIndex: false,
            fontIcon: 'file-invoice-dollar',
            router: '',
            tabContentProps: null,
            tabHeaderProps: {},
        },
        {
            menuItem: 'AGREEMENT',
            defaultActiveIndex: false,
            fontIcon: 'map-marker-alt',
            router: '',
            tabContentProps: null,
            tabHeaderProps: {},
        },
    ],
    action: value => {
        //console.log(('Put Action here', value);
    },
    activeIndex: 0,
    config: {
        dataErrorMessage: `'No Data Available'`,
    },
}

export default MasterTab
